let storage = window.localStorage;
let localStorage = {
    getItem: function (key){
        let value = storage.getItem(key);        
        if (value === null){
            return false;
        }
        if (value && value.substring(0, 1) === "{" || value.substring(0, 1) == "[") {  // 判断字符串是否是对象或则数组结构
            value = JSON.parse(value);  //将字符串转成json
        }
        return value
    },
    setItem: function (key,value){
        if(getType(value) === 'Object' || getType(value) === 'Array') {            
            value = JSON.stringify(value);
        }
        storage.setItem(key, value);
    },
     // 删除项
    removeItem: function (key) {
        this.getItem(key) && storage.removeItem(key);
    },
    //  清空
    clear: function () {
        storage.clear(); // 清空本地存储
    },
}

function getType(object) {
    /**
     * 方法来源：prototype.js
     * getType(5); // => "Number"
     * getType({}); // => "Object"
     * getType(/foo/); // => "RegExp"
     * getType(''); // => "String"
     * getType(true); // => "Boolean"
     * getType([]); // => "Array"
     * getType(undefined); // => "Window"
     * getType(Element); // => "Constructor"
     **/
    return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1];
}

export default {
    install: function (vm) {
        vm.prototype.$localStorage = localStorage;
    }
}


// WEBPACK FOOTER //
// ./src/lib/Zplug.js